exports = module.exports = require("../../node_modules/@vue/cli-service/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".vtable {\n  clear: both;\n}\n.vtable .ant-table-body {\n  overflow: auto !important;\n}\n", ""]);

// exports
